import * as msal from '@azure/msal-browser'
import store from '../store'
import http from '@/utils/ajax'
import router from '@/router'
import { MSAL_LOADING, USER_TOKEN_REMOVE, USER_SESSION_EXPIRED, USER_DEFAULT_BRANCH } from '../store/types'

export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: process.env.VUE_APP_MSAL_AUTH + process.env.VUE_APP_MSAL_TENANT_ID,
    redirectUri: process.env.VUE_APP_UIURL,
    postLogoutRedirectUri: process.env.VUE_APP_UIURL
  },
  cache: {
    cacheLocation: process.env.VUE_APP_CACHE_LOC,
    storeAuthStateInCookie: process.env.VUE_APP_STORE_IN_COOKIE
  }
}

export const loginRequest = {
  scopes: process.env.VUE_APP_SCOPE.split(','),
  prompt: 'select_account'
}

export const msalInstance = new msal.PublicClientApplication(msalConfig)

export async function login() {
  try {
    await msalInstance.loginRedirect(loginRequest)
  } catch (err) {
    console.error('Login failed:', err)
  }
}

export async function logout() {
  logoutCommit()
  try {
    localStorage.removeItem('accessToken')
    const account = msalInstance.getActiveAccount()
    await msalInstance.logoutRedirect({
      account
    })
  } catch (err) {
    console.error('Logout failed:', err)
  }
}

export async function ssoauth() {
  try {
    msalInstance.handleRedirectPromise().then(async response => {
      try {
        if (response) {
          store.commit(MSAL_LOADING, true)
          const accounts = msalInstance.getAllAccounts()
          if (!accounts.length) throw new Error('Invalid account.')

          const tokensilent = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
          })
          msalInstance.setActiveAccount(tokensilent.account)
          localStorage.setItem('accessToken', response.accessToken)
          http
            .get(store.state.app.baseMenu.msSSOAuth, {
              headers: {
                Authorization: `Bearer ${response.accessToken}`
              }
            })
            .then(ssoresponse => {
              const { data } = ssoresponse
              if (Object.keys(data).length > 0) {
                store.dispatch('processLoginForm', ssoresponse).then(() => {
                  store.commit(MSAL_LOADING, false)
                  router.push({ name: 'dashboard' })
                })
              } else {
                this.$toast.error('Invalid O5 user login. Please inform the System Administrator.')
              }
            })
        }
      } catch (err) {
        console.error(err)
      }
    })
  } catch (err) {
    console.error(err)
  }
}

function logoutCommit() {
  store.commit(USER_TOKEN_REMOVE)
  store.commit(USER_SESSION_EXPIRED)
  store.commit(USER_DEFAULT_BRANCH, '')
}

export async function acquireAccount() {
  const accounts = msalInstance.getAllAccounts()
  if (!accounts.length) throw new Error('Invalid account.')

  const tokensilent = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: accounts[0]
  })
  return tokensilent.account
}

export const msalPlugin = {
  install(Vue) {
    Vue.prototype.$msal = {
      instance: msalInstance,
      login,
      logout,
      ssoauth
    }
  }
}
